import { TStore } from "redux/reducer";
import { createSelector } from "reselect";

export const selectTestCronState = (state: TStore) => state.cronTests;

export const selectUsersForTestsCrone = createSelector([selectTestCronState], (state) => state);
